import React from 'react';

function SunneyProblem() {
    return(
        <section class="sunney-problem">
        <h2>The Problem:</h2>
        <p>The constant pursuit of internships, job applications, and 
            academic excellence can leave seniors and juniors little room to relax, 
            leading to a pervasive sense of burnout that permeates their final years on campus.
        </p>
    </section>
    );
}

export default SunneyProblem;